import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['columnSelect', 'functionSelect', 'labelInput'];
  static values = { functions: Array };

  connect() {
    if (this.hasColumnSelectTarget && this.columnSelectTarget.value) {
      this.columnChanged({ target: this.columnSelectTarget });
    }
  }

  columnChanged(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption || !selectedOption.value) {
      this.resetFunctionSelect([]);
      return;
    }

    const columnType = selectedOption.dataset.columnType;
    const compatible = this.functionsValue.filter(
      (fn) => fn.types === 'all' || (Array.isArray(fn.types) && fn.types.includes(columnType))
    );

    this.resetFunctionSelect(compatible);
    this.updateLabel();
  }

  functionChanged() {
    this.updateLabel();
  }

  resetFunctionSelect(functions) {
    this.functionSelectTarget.options.length = 0;
    functions.forEach((fn) => this.functionSelectTarget.add(new Option(fn.label, fn.value)));
    this.functionSelectTarget.selectedIndex = functions.length ? 0 : -1;
  }

  updateLabel() {
    if (!this.hasLabelInputTarget) return;

    const columnName = this.columnSelectTarget.value
      ? this.columnSelectTarget.value.split('.').pop()
      : '';
    const functionOption =
      this.functionSelectTarget.options[this.functionSelectTarget.selectedIndex];
    const functionLabel = functionOption ? functionOption.text : '';

    if (columnName && functionLabel) {
      this.labelInputTarget.value = `${functionLabel} of ${this.generateLabel(columnName)}`;
    }
  }

  generateLabel(columnName) {
    return columnName.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  }
}
